/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BenchmarkRunSummaryDtoPaginatedResult } from '../../models/benchmark-run-summary-dto-paginated-result';

export interface ApiAdminBenchmarksBenchmarkIdRunsGet$Params {
  benchmarkId: string;
  cursor?: string;
  limit?: number;
}

export function apiAdminBenchmarksBenchmarkIdRunsGet(http: HttpClient, rootUrl: string, params: ApiAdminBenchmarksBenchmarkIdRunsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunSummaryDtoPaginatedResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarksBenchmarkIdRunsGet.PATH, 'get');
  if (params) {
    rb.path('benchmarkId', params.benchmarkId, {});
    rb.query('cursor', params.cursor, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BenchmarkRunSummaryDtoPaginatedResult>;
    })
  );
}

apiAdminBenchmarksBenchmarkIdRunsGet.PATH = '/api/Admin/benchmarks/{benchmarkId}/runs';
